import React, { useEffect, useState, useRef } from "react";
import Styles from "../../../assets/css/Blogs/RealLifeGadgets/SmartClock.module.css";
import { useGlobalState } from "../../../Functions/GlobalStates";
import debounce from "lodash.debounce";
import Loading from "../../Loadings/Loading";
import { Helmet } from "react-helmet-async";

const SmartClock = () => {
  // States Here
  const [IsLoaded, setIsLoaded] = useState(false); // I CAN use this to show loading before all images loads
  // Global States Here //////////////////////////////////////////////////////...............................
  const {
    CheckPage,
    setCheckPage,
    DontAllow,
    setDontAllow,
    PagesWidthHeight,
    setPagesWidthHeight,
  } = useGlobalState();

  // React Elements References Here //////////////////////////////////// ...............
  const CheckPageStateRef = useRef(false); // Ref for the check Page
  const SmartClockHeight = useRef(false); // Ref for the absolute box

  const ProductImages = require.context(
    "../../../assets/images/Blogs/RealLifeGadgets/SmartClock",
    false,
    /\.(png|jpe?g|gif|bmp|webp|svg|avif)$/
  );
  const ProductImagesArray = [
    ProductImages("./10.avif"),
    ProductImages("./13.avif"),
    ProductImages("./16.avif"),
    ProductImages("./17.avif"),
    ProductImages("./18.avif"),
  ];

  // Show And Hide Navbar DropMenu HomePage
  useEffect(() => {
    const handleCheckResize = () => {
      if (!CheckPageStateRef.current) {
        CheckPageStateRef.current = true;
        setCheckPage(true);
        setDontAllow(true);
      }
      // console.log("oN Mount", CheckPageStateRef.current);
      // console.log("Mounted User Entered");
    };
    handleCheckResize(); // call on mount

    // Add the resize event listener
    window.addEventListener("resize", handleCheckResize);

    // Update global state when the component unmounts , It mean when The user Leaves This Page
    return () => {
      if (CheckPageStateRef.current) {
        CheckPageStateRef.current = false;
        setCheckPage(true);
        setDontAllow(false);
      }
      // console.log("oN unMOUNT", CheckPageStateRef.current);
      // console.log("Unmounted User Leaved");
      window.removeEventListener("resize", handleCheckResize);
    };
  }, []);

  // Preload Images Before render it will help to descrease flickers on img change
  useEffect(() => {
    const preloadImages = async (imageArray, callback) => {
      try {
        await Promise.all(
          imageArray.map((src) => {
            return new Promise((resolve, reject) => {
              const img = new Image();
              img.src = src;
              img.onload = resolve;
              img.onerror = reject; // Add error handling
            });
          })
        );
        callback(); // Callback after all images are preloaded
      } catch (error) {
        console.error("Error preloading image:", error);
      }
    };

    preloadImages([ProductImagesArray[0]], () => {
      setIsLoaded(true); // Set state when all images are loaded
      // console.log("All Images Are Loaded");
    });
  }, []);

  // updating height to modify Navbar DropMenu height
  useEffect(() => {
    const updateSize = () => {
      if (SmartClockHeight.current) {
        const { width, height } =
          SmartClockHeight.current.getBoundingClientRect();
        setPagesWidthHeight((prev) => ({
          ...prev,
          height: parseFloat(height.toFixed(1)),
        }));
      }
    };

    updateSize(); // Run once on mount
    // Debounce Will Help Derease the Consuption of the Ram & Limit Bulk re-Runing Funtions in a Sec
    const updateSizeDelay = debounce(updateSize, 100);
    window.addEventListener("resize", updateSize);
    window.addEventListener("scroll", updateSizeDelay);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      window.removeEventListener("resize", updateSize);
      window.removeEventListener("scroll", updateSizeDelay);
    };
  }, []); // Empty dependency array to run only on mount and unmount

  return IsLoaded ? (
    <>
      <Helmet>
        {/* Page Title */}
        <title>Smart Clock Gadget for Your Daily Convenience ⏰</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Discover why smart clocks are so popular! Explore their advanced features like gentle alarms, premium sound, and easy smart home control."
        />

        {/* Keywords for SEO */}
        <meta
          name="keywords"
          content="Smart Clocks, Alarm Clocks, Home Gadgets, Smart Home Devices, Voice Control, Alexa Clocks, Tech Gadgets"
        />

        {/* Responsive Design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph Meta Tags for Social Sharing */}
        <meta
          property="og:title"
          content="Smart Clock Gadget for Your Daily Convenience ⏰"
        />
        <meta
          property="og:description"
          content="Discover why smart clocks are so popular! Explore their advanced features like gentle alarms, premium sound, and easy smart home control."
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://affiliators.netlify.app/#/reallifegadgets/smartclock"
        />
        {/* <meta property="og:image" content="/images/SmartClock/10.png" /> */}

        {/* Twitter Meta Tags for Social Sharing */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Smart Clock Gadget for Your Daily Convenience ⏰"
        />
        <meta
          name="twitter:description"
          content="Discover why smart clocks are so popular! Explore their advanced features like gentle alarms, premium sound, and easy smart home control."
        />
        {/* <meta name="twitter:image" content="/images/SmartClock/10.png" /> */}

        {/* Robots Meta Tag */}
        <meta name="robots" content="index, follow" />

        {/* Canonical URL */}
        {/* <link
          rel="canonical"
          href="https://affiliators.netlify.app/#/reallifegadgets/smartclock"
        /> */}

        {/* Additional Meta Tags */}
        <meta name="author" content="Zeeshan Ahmad Kamran" />
        <meta name="language" content="en" />
        <meta http-equiv="Content-Language" content="en" />
      </Helmet>

      <div ref={SmartClockHeight} className={Styles.SmartClockContainer}>
        <section className={Styles.SmartClockSection1}>
          <div className={Styles.SmartClockSection1Text1Container}>
            {/* <h1>Echo Spot – The Smart Clock Everyone Wants ⏰🎶</h1> */}
          </div>
          <img
            src={`${ProductImagesArray[0]}`}
            alt="Smart Clock"
            title="This is an AI-generated representation. Actual product may vary."
          />
          <p>
            These images are AI-generated representations of the products.
            Actual appearance, specifications, features, and colors may vary.
            For the most accurate and up-to-date product details, please refer
            to the official product page via the button at the end of this blog.
          </p>
          <div className={Styles.SmartClockSection1Text2Container}>
            <h1>| Smart Clock |</h1>
            <h1>Why Smart Clocks Are So Popular 🚀</h1>
            <p>
              This is not just a smart alarm clock—it’s a must-have smart home
              device. With its sleek, circular design, vibrant display, and
              built-in Alexa, it has become a favorite among tech lovers and
              busy individuals. Whether you need a peaceful wake-up, hands-free
              controls, or immersive sound, this device makes life easier and
              more enjoyable.
            </p>
          </div>
          <div className={Styles.SmartClockSection1Img2Container}>
            <img
              src={`${ProductImagesArray[1]}`}
              alt="Smart Clock"
              title="This is an AI-generated representation. Actual product may vary."
            />
            <img
              src={`${ProductImagesArray[2]}`}
              alt="Smart Clock"
              title="This is an AI-generated representation. Actual product may vary."
            />
          </div>
          <div className={Styles.SmartClockSection1Text3Container}>
            <h1>Smart Features That Stand Out ⭐</h1>
            <p>
              <span style={{ color: "black" }}>✅ Wake Up Gently 🌅</span> Say
              goodbye to loud, jarring alarms, It helps you wake up with gradual
              lighting and soothing sounds, making your mornings more relaxed
              and refreshing.
            </p>
            <p>
              <span style={{ color: "black" }}>
                ✅ Premium Sound Quality 🎵
              </span>{" "}
              Immerse yourself in rich sound with crystal-clear vocals and deep
              bass. Whether you’re enjoying music, podcasts, or audiobooks,
              experience high-quality audio anytime.
            </p>
            <p>
              <span style={{ color: "black" }}>
                ✅ Easy Smart Home Control 🏡
              </span>{" "}
              With just your voice or a tap, adjust lights, thermostats, and
              other smart devices. Alexa makes managing your home effortless and
              efficient.
            </p>
            <p>
              <span style={{ color: "black" }}>✅ Customizable Display 🎨</span>{" "}
              Personalize your clock face, themes, and colors to match your
              style and home décor.
            </p>
            <p>
              <span style={{ color: "black" }}>
                ✅ Hands-Free Convenience 🎙️
              </span>
              Thanks to far-field microphones, Alexa can hear you from across
              the room, making voice commands seamless and responsive.
            </p>
            <p>
              <span style={{ color: "black" }}>✅ Privacy & Security 🔒</span>
              Built with multiple layers of privacy, including a mic-off button
              and app-based controls, ensuring you stay in charge of your data.
            </p>
            <p>
              <span style={{ color: "black" }}>✅ Sustainable Design 🌍</span>
              Made with up to 36% recycled materials, making it an eco-friendly
              choice for smart home users.
            </p>
          </div>
          <div className={Styles.SmartClockSection1Img3Container}>
            <img
              src={`${ProductImagesArray[4]}`}
              alt="Smart Clock"
              title="This is an AI-generated representation. Actual product may vary."
            />
            <img
              src={`${ProductImagesArray[3]}`}
              alt="Smart Clock"
              title="This is an AI-generated representation. Actual product may vary."
            />
          </div>
          <div className={Styles.SmartClockSection1Text4Container}>
            <h1>Perfect for Any Room 🏠</h1>
            <p>
              Whether it’s on your bedside table, office desk, or kitchen
              counter, It blends style and function effortlessly. It keeps you
              organized, entertained, and in control of your home with minimal
              effort.
            </p>
          </div>
          <div className={Styles.SmartClockSection1Text5Container}>
            <h4>
              🔔 If you're interested, similar products are available through
              the provided sources.
            </h4>
          </div>
          <a
            title="This link leads to an affiliate product page. We may earn a commission at no extra cost to you."
            href="https://amzn.to/3ECBstY"
            target="_blank"
            rel="noopener noreferrer"
            className={Styles.SmartClockSection1BtnAmazonAncherContainer}
          >
            <button
              title="This button leads to an affiliate product page. We may earn a commission at no extra cost to you."
              className={Styles.SmartClockSection1BtnAmazon}
            >
              Buy Now on <span>&nbsp;&nbsp;Amazon</span> <span>&nbsp;»</span>
            </button>
          </a>
          <div className={Styles.SmartClockSection1DesclaimerContainer}>
            <h1>Affiliate Disclaimer 💬</h1>
            <p>
              As an Amazon Associate, I earn from qualifying purchases. This
              helps support the blog at no extra cost to you.
            </p>
            <h1>AI-Generated Images Disclaimer</h1>
            <p>
              The product images on this site are AI-generated representations
              created for illustrative purposes only. They may not perfectly
              match the actual product in terms of color, design, or features.
              For accurate details and images, please refer to the official
              product listing on Amazon by clicking the provided links.
            </p>
            <h1>HashTags</h1>
            <p>
              #SmartClock #AlexaClock #VoiceControl #TechGadgets #DigitalClock
              #SmartHome #AlarmClock #WiFiClock #HomeAutomation #DigitalProducts
            </p>
            <h1>Keywords</h1>
            <p>
              Best smart clock for 2025 with voice control Smart alarm clock
              with Alexa for hands-free convenience Modern digital clock with
              weather updates and reminders WiFi-enabled smart clock with
              customizable display Touchscreen bedside clock with smart home
              integration Voice-activated alarm clock with Bluetooth speaker
              Energy-efficient smart clock with auto-dimming display
            </p>
          </div>
        </section>
      </div>
    </>
  ) : (
    <Loading />
  );
};

export default SmartClock;
